/*******************************************************************************
 * ItemReversal */
/**
 * @ngdoc   run
 * @module  csm.books.nsf
 * @name    csm.books.nsf.run:ItemReversal
 * @description
 * Creates a data object constructor by setting default values and functions on
 * the prototype. The data will be initialized from the `item`.
 *******************************************************************************/
/* @ngInject */ export function runItemReversalData(Data) {
  /*****************************************************************************
   * Constructor
   *****************************************************************************/
  Data.ItemReversal = function (item) {
    var itemReversal = Object.assign(
      Object.create(Data.ItemReversal.prototype),
      item || {}
    );
    return itemReversal;
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  Data.ItemReversal.prototype = {
    amount: 0,
    mReversal: 0,
    entityID: NaN,
    ledgerItemID: NaN,
    memo: null,
    name: null,
    referenceItemID: NaN,

    /*--------------------------------*/
    /* Ensure that we don't reverse   */
    /* more than the original amount. */
    /*--------------------------------*/
    get reversal() {
      return this.mReversal;
    },
    set reversal(value) {
      this.mReversal = Math.min(this.amount, value);
    }
  };
};
